import {UI} from "../../../../../stem-core/src/ui/UIBase.js";
import {MerchantStore} from "../../../../../client/state/MerchantStore.js";
import {DonationOfferStore} from "../../../../../client/state/DonationOfferStore.js";
import {DonationStore} from "../../../../../client/state/DonationStore.js";
import {Toast} from "../../../../ui/Toast.jsx";
import {ConfirmationModal} from "../../../../ui/ConfirmationModal.jsx";
import {Messages} from "../../../../Messages.js";
import {autoredraw} from "../../../../../stem-core/src/decorators/AutoRedraw.js";
import {apiCancelDonation} from "../../../../../client/state/DonationStore.js";


@autoredraw(DonationStore)
export class CancelDonationModal extends ConfirmationModal {
    getDefaultOptions() {
        const {donation} = this.options;
        const offer = DonationOfferStore.get(donation.recurringOfferId);
        const merchant = MerchantStore.get(offer.merchantId);
        return Object.assign({}, super.getDefaultOptions(), {
            title: Messages.cancelDonationTitle,
            description: Messages.cancelDonationDescription(merchant.name),
            confirmAction: () => this.cancel(),
            cancelLabel: Messages.close,
            confirmLabel: Messages.cancelDonation,
        });
    }

    async cancel() {
        const {donation} = this.options;

        if (!donation) {
            return;
        }

        try {
            await apiCancelDonation(donation);
            Toast.show(Messages.cancelDonationSuccess);
            this.hide();
        } catch (error) {
            Toast.showError(error);
            this.redraw();
        }
    }
}
